import _ from "lodash";
import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import LearningStandards from "./routes/LearningStandards";
import SubjectSetup from "./routes/SubjectsSetup";
import Atls from "Administrator/commonComponents/Atls";
import KeyConcepts from "./routes/KeyConcepts";
import StudentProfileTemplates from "Administrator/commonComponents/StudentProfileTemplates";
import FieldsConfiguration from "Administrator/commonComponents/FieldsConfiguration";
import ManageTemplates from "Administrator/commonComponents/ManageTemplates";
import RoutineAndMealTemplates from "Administrator/commonComponents/RoutineAndMealTemplates";
import AssessmentToolSetup from "AssessmentToolSetup";
import EvaluationCriteria from "EvaluationCriteria";
import AssessmentCriteria from "AssessmentCriteria";
import LearnerProfileAttributes from "Administrator/commonComponents/LearnerProfileAttributes";
import ScoreCategories from "ScoreCategories";
import Continuum from "Continuum";
import AssessmentSetup from "../DPAcademicSetup/routes/AssessmentSetup";
import AssessmentCategories from "../DPAcademicSetup/routes/AssessmentCategories";
import { updateChildRoutes } from "Administrator/modules/AdministratorModule";
import LocalGrades from "Administrator/commonComponents/LocalGrades";
import GradingPeriods from "Administrator/commonComponents/GradingPeriods";
import GradingPeriodsV3 from "Administrator/commonComponents/GradingPeriodsV3";
import GradingSetup from "Administrator/commonComponents/GradingSetup";
import GradingSetupV2 from "Administrator/commonComponents/GradingSetupV2";
import AssessmentSettingsEvaluationCriteria from "Administrator/commonComponents/AssessmentSettingsEvaluationCriteria";
import GpaAndCredits from "Administrator/commonComponents/GpaAndCredits";
import GradeScaleSetup from "Administrator/commonComponents/GradeScaleSetup";
import PlannerElementSetConfiguration from "Administrator/commonComponents/PlannerElementSetConfiguration";
import AssessmentTypes from "Administrator/commonComponents/GradingSetup/routes/AssessmentTypes";
import WorkbookTemplates from "../../commonComponents/WorkbookTemplates";
import SubjectStandardsV2 from "Administrator/commonComponents/SubjectStandardsV2";
import Datasets from "Datasets";

export default store => ({
  path: "ubdAcademicSetup",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
        import(
          /* webpackChunkName: "admin-academicSetup" */ "Administrator/routes/AcademicSetup/routes/SubjectsSetup/modules/SubjectsModule.js"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "subjectsSetup",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter(nextState, replace) {
    const { routes } = nextState;
    const pathname = _.get(nextState, "location.pathname");
    if (_.includes(pathname, "/evaluationCriteria")) {
      const updatedPathname = _.replace(
        pathname,
        "/evaluationCriteria",
        "/evaluation-criteria"
      );
      return replace(updatedPathname);
    }
    store.dispatch(
      updateChildRoutes({
        routes,
        path: "ubdAcademicSetup",
        pathId: "UBD_ACADEMIC_SETUP",
        type: "replace",
      })
    );
  },
  childRoutes: [
    LearningStandards(store),
    SubjectStandardsV2(store),
    Datasets(store),
    SubjectSetup(store),
    Atls(store),
    KeyConcepts(store),
    LearnerProfileAttributes(store),
    StudentProfileTemplates(store),
    FieldsConfiguration(store),
    PlannerElementSetConfiguration(store),
    ManageTemplates(store),
    RoutineAndMealTemplates(store),
    AssessmentToolSetup(store),
    EvaluationCriteria(store),
    AssessmentCriteria(store),
    ScoreCategories(store),
    Continuum(store),
    AssessmentSetup(store),
    AssessmentCategories(store),
    LocalGrades(store),
    GradingPeriods(store),
    GradingPeriodsV3(store),
    GradingSetup(store),
    GradingSetupV2(store),
    AssessmentSettingsEvaluationCriteria(store),
    GpaAndCredits(store),
    GradeScaleSetup(store),
    AssessmentTypes(store), // Once grading setup is live, it will come inside it and will be removed from here
    WorkbookTemplates(store),
  ],
});
